import { privateApi, privateApiWithBlob } from "./axios";

// DOSSIER CLIENT
export const getCustomerFiles = async () => {
    try {
        const response = await privateApi.get("api/sc/customerfile");
        return response;
    } catch (error) {
        throw error;
    }
};

export const postMonth = async (id: number, month: any, unitPrice: any) => {
    try {
        const response = await privateApi.post(`api/sc/customerfile/${id}/month`, {sc_Month: month, sc_UnitPrice: unitPrice})
        return response
    } catch (error) {
        throw error;
    }
}

export const getExportSage = async (id: number) => {
    try {
        const response = await privateApiWithBlob.get(`api/sc/customerfile/${id}/sage-export`, {responseType: "blob"})
        return response
    } catch (error) {
        throw error;
    }
}

export const validateSaisie = async (id: number) => {
    try {
        const response = await privateApi.post(`api/sc/customerfile/${id}/completed`)
        return response
    } catch (error) {
        throw error;
    }
}

export const validateMonth = async (id: number) => {
    try {
        const response = await privateApiWithBlob.get(`api/sc/customerfile/${id}/close`, {
            responseType: "blob",
        })
        return response
    } catch (error) {
        throw error;
    }
}

export const downloadAllDocuments = async (id: number) => {
    try {
        const response = await privateApi.get(`api/sc/customerfile/${id}/documents/zip`, {responseType: "blob"})
        return response
    } catch (error) {
        throw error;
    }
}

export const downloadAllBulletins = async (id: number) => {
    try {
        const response = await privateApi.get(`api/sc/customerfile/${id}/bulletins/zip`, {responseType: "blob"})
        return response
    } catch (error) {
        throw error;
    }
}

// SALARIES
export const getRecapSalaries = async (id: number, language: "FR" | "EN") => {
    try {
        const response = await privateApi.get(`api/sc/customerfile/${id}/social-export?lang=${language}`, {responseType: "blob"})
        return response
    } catch (error) {
        throw error;
    }
}

export const getEmployees = async (id: number) => {
    try {
        const response = await privateApi.get(`api/sc/customerfile/${id}/employees`);
        return response;
    } catch (error) {
        throw error;
    }
};

export const createEmployee = async (idCustomer: number, data: any) => {
    try {
        const response = await privateApi.post(`api/sc/customerfile/${idCustomer}/employee`, data)
        return response
    } catch (error) {
        throw error;
    }
}

export const getEmployee = async (id: number) => {
    try {
        const response = await privateApi.get(`api/sc/employees/${id}`)
        return response
    } catch (error) {
        throw error;
    }
}

export const deleteEmployee = async (id: number) => {
    try {
        const response = await privateApi.delete(`api/sc/employees/${id}`)
        return response
    } catch (error) {
        throw error;
    }
}

export const updateEmployee = async (id: number, data: any) => {
    try {
        const response = await privateApi.patch(`api/sc/employees/${id}`, data)
        return response
    } catch (error) {
        throw error;
    }
}

export const importEmployees = async (id: number, data: any) => {
    try {
        const response = await privateApiWithBlob.post(`api/sc/customerfile/${id}/employees/import`, data)
        return response
    } catch (error) {
        throw error;
    }
}

// ASSIGNATION
export const createContactSocial = async (id: number, data: any) => {
    try {
        const response = await privateApi.post(`api/sc/customerfile/${id}/users`, data)
        return response
    } catch (error) {
        throw error;
    }
}

export const getUsersAssignByCustomer = async (id: number) => {
    try {
        const response = await privateApi.get(`api/sc/customerfile/${id}/users`)
        return response
    } catch (error) {
        throw error;
    }
} 

export const getCollabAssignByCustomer = async (id: number) => {
    try {
        const response = await privateApi.get(`api/sc/customerfile/${id}/collaborators`)
        return response
    } catch (error) {
        throw error;
    }
}

export const desassignCollaborators = async (idCustomer: number, id: number) => {
    try {
        const response = await privateApi.delete(`api/sc/customerfile/${idCustomer}/collaborator/${id}`)
        return response
    } catch (error) {
        throw error;
    }
}

export const assignCollaboratorsSocial = async (idCustomer: number, id: number) => {
    try {
        const response = await privateApi.post(`api/sc/customerfile/${idCustomer}/collaborator/${id}`)
        return response
    } catch (error) {
        throw error;
    }
}

export const deleteUser = async (idCustomer: number, id: number) => {    
    try {
        const response = await privateApi.delete(`api/sc/customerfile/${idCustomer}/user/${id}`)
        return response
    } catch (error) {
        throw error;
    }
}

// TYPE INPUT
export const getTypesInputValeur = async (lang: string) => {
    try {
        const response = await privateApi.get(`api/sc/typeinput/monthly?lang=${lang}`)
        return response
    } catch (error) {
        throw error;
    }
}

export const getTypesInputAbscence = async (lang: string) => {
    try {
        const response = await privateApi.get(`api/sc/typeinput/absences?lang=${lang}`)
        return response
    } catch (error) {
        throw error;
    }
}

// VALEURS
export const createValeur = async (id: number, data: any) => {
    try {
        const response = await privateApi.post(`api/sc/employees/${id}/monthly`, data)
        return response
    } catch (error) {
        throw error;
    }
}

export const updateValeur = async (id: number, data: any) => {
    try {
        const response = await privateApi.patch(`api/sc/employees/monthly/${id}`, data)
        return response
    } catch (error) {
        throw error;
    }
}

export const getValeur = async (id: number) => {
    try {
        const response = await privateApi.get(`api/sc/employees/monthly/${id}`)
        return response
    } catch (error) {
        throw error;
    }
}

export const deleteValeur = async (id: number) => {
    try {
        const response = await privateApi.delete(`api/sc/employees/monthly/${id}`)
        return response
    } catch (error) {
        throw error;
    }
}

// ABSENCES
export const createAbsence = async (id: number, data: any) => {
    try {
        const response = await privateApi.post(`api/sc/employees/${id}/absences`, data)
        return response
    } catch (error) {
        throw error;
    }
}

export const updateAbsence = async (id: number, data: any) => {
    try {
        const response = await privateApi.patch(`api/sc/employees/absences/${id}`, data)
        return response
    } catch (error) {
        throw error;
    }
}

export const getAbsence = async (id: number) => {
    try {
        const response = await privateApi.get(`api/sc/employees/absences/${id}`)
        return response
    } catch (error) {
        throw error;
    }
}

export const deleteAbsence = async (id: number) => {
    try {
        const response = await privateApi.delete(`api/sc/employees/absences/${id}`)
        return response
    } catch (error) {
        throw error;
    }
}

// DOCUMENTS EMPLOYEES
export const getDocuments = async (id: number) => {
    try {
        const response = await privateApi.get(`api/sc/employees/${id}/documents`)
        return response
    } catch (error) {
        throw error;
    }
}

export const postDocuments = async (id: number, data: any, config?: object) => {
    try {
        const response = await privateApiWithBlob.post(`api/sc/employees/${id}/document`, data, config)
        return response
    } catch (error) {
        throw error;
    }   
}

// DOCUMENTS CUSTOMER
export const getDocumentsCustomer = async (id: number) => {
    try {
        const response = await privateApi.get(`api/sc/customerfile/${id}/documents`)
        return response
    } catch (error) {
        throw error;
    }
}

export const postDocumentsCustomer = async (id: number, data: any, config?: object) => {
    try {
        const response = await privateApiWithBlob.post(`api/sc/customerfile/${id}/document`, data, config)
        return response
    } catch (error) {
        throw error;
    }
}

// DOCUMENTS 
export const getDocument = async ( idDoc: number) => {
    try {
        const response = await privateApi.get(`api/sc/document/${idDoc}`, {responseType: "blob"})
        return response
    } catch (error) {
        throw error;
    }
}

export const deleteDocument = async (idDoc: number) => {
    try {
        const response = await privateApi.delete(`api/sc/document/${idDoc}`)
        return response
    } catch (error) {
        throw error;
    }
}


// CHAT
export const getMessages = async (id: number) => {
    try {
        const response = await privateApi.get(`api/sc/customerfile/${id}/chat/messages`)
        return response
    } catch (error) {
        throw error;
    }
}

export const sendMessage = async (id: number, data: any) => {
    try {
        const response = await privateApi.post(`api/sc/customerfile/${id}/chat/message`, {message: data})
        return response
    } catch (error) {
        throw error;
    }
}

// BULLETINS
export const getBulletin = async (id: number) => {
    try {
        const response = await privateApi.get(`api/sc/customerfile/${id}/payslips`, {responseType: "blob"})
        return response
    } catch (error) {
        throw error;
    }
}

export const validateBulletins = async (id: number) => {
    try {
        const response = await privateApi.post(`/api/sc/customerfile/${id}/payslips/validate`)
        return response
    } catch (error) {
        throw error;
    }
}

export const refusedBulletins = async (id: number, data: any) => {
    try {
        const response = await privateApi.post(`api/sc/customerfile/${id}/payslips/refuse`, data)
        return response
    } catch (error) {
        throw error;
    }
}

export const getHistoryMessages = async (id: number) => {
    try {
        const response = await privateApi.get(`api/sc/customerfile/${id}/payslips/validationhistory`)
        return response
    } catch (error) {
        throw error;
    }
}

export const postBulletins = async (id: number, data: any) => {
    try {
        const response = await privateApiWithBlob.post(`api/sc/customerfile/${id}/payslips`, data)
        return response
    } catch (error) {
        throw error;
    }
}

export const updateNumberOfBulletins = async (id: number, data: any) => {
    try {
        const response = await privateApi.patch(`api/sc/customerfile/${id}/payslips/numberofpages`, data)
        return response
    } catch (error) {
        throw error;
    }
}

export const getNumberOfBulletins = async (id: number) => {
    try {
        const response = await privateApi.get(`api/sc/customerfile/${id}/payslips/numberofpages`)
        return response
    } catch (error) {
        throw error;
    }
}

// Pour les missions
export const getSocialStructure = async () => {
    try {
        const response = await privateApi.get(`api/sc/missions/structure-types`)
        return response
    } catch (error) {
        throw error;
    }
}

export const getSocialDiscount = async () => {
    try {
        const response = await privateApi.get(`api/sc/missions/discounts`)
        return response
    } catch (error) {
        throw error;
    }
}

// Validation employée
export const validateEmployee = async (id: number) => {
    try {
        const response = await privateApi.post(`api/sc/employees/${id}/finish`)
        return response
    } catch (error) {
        throw error;
    }
}

export const unvalidateEmployee = async (id: number) => {
    try {
        const response = await privateApi.post(`api/sc/employees/${id}/unfinished`)
        return response
    } catch (error) {
        throw error;
    }
}

// Commentaire par employé
export const postCommentary = async (id: number, data: any) => {
    try {
        const response = await privateApi.post(`api/sc/employees/${id}/misc-data`, data)
        return response
    } catch (error) {
        throw error;
    }
}

export const updateCommentary = async (id: number, data: any, idMisc: number) => {
    try {
        const response = await privateApi.patch(`api/sc/employees/${id}/misc-data/${idMisc}`, data)
        return response
    } catch (error) {
        throw error;
    }
}

export const deleteCommentary = async (id: number, idMisc: number) => {
    try {
        const response = await privateApi.delete(`api/sc/employees/${id}/misc-data/${idMisc}`)
        return response
    } catch (error) {
        throw error;
    }
}

export const unvalidated = async (idCustomer : number) => {
    try {
        const response = await privateApi.post(`api/sc/customerfile/${idCustomer}/uncompleted`)
        return response
    } catch (error) {
        throw error
    }
}

// GUIDE
export const getGuideSocial = async (lang: string) => {
    try {
        const response = await privateApiWithBlob.get(`api/sc/guides/${lang}`, {responseType: "blob"})
        return response
    } catch (error) {
        throw error;
    }
}

export const postGuideSocial = async (lang: string, data: any) => {
    try {
        const response = await privateApiWithBlob.post(`api/sc/guides/${lang}`, data)
        return response
    } catch (error) {
        throw error;
    }
}